export default __webpack_public_path__ + "static/media/home-restaurant-img-01.737d7f6a.png";